module.exports = __webpack_public_path__ + "img/Login.64b8bc85.jpg";